import { MoonLoader, RingLoader } from "react-spinners";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import complete from "../../assets/images/complete.png";
import Button from "../../components/bootstrap/Button";
import ReportService from "../../services/ReportService";
import PageWrapper from "../../layout/PageWrapper/PageWrapper";
import Page from "../../layout/Page/Page";
import { useMst } from "../../models";

const base = {
  9: 9,
  10: 11,
  11: 12,
  12: 13,
  13: 14,
  14: 15,
  15: 16,
  16: 17,
  17: 18,
  18: 19,
  19: 20,
  20: 21,
  21: 22,
  22: 23,
  23: 24,
  24: 25,
  25: 26,
  26: 27,
  27: 28,
  28: 29,
  29: 30,
  30: 31,
  31: 32,
  32: 33,
  33: 34,
  34: 38,
  35: 40,
  36: 44,
};

const strengthBase = {
  US: 35,
  VS: 33,
  S: 29,
  M: 22,
  L: 15,
  VL: 9,
};

const Loading = () => {
  const { user } = useMst();

  const naviagte = useNavigate();
  const location = useLocation();

  const [isComplete, setIsComplete] = useState(false);
  const [result, setResult] = useState({});

  const [dots, setDots] = useState('.');

  const calculate = (sum, reportType) => {
    const normalized = {
      A: 0,
      D: 0,
      R: 0,
      E: 0,
    };

    const strength = {
      A: "",
      D: "",
      R: "",
      E: "",
    };

    normalized.A = base[sum.A];
    normalized.D = base[sum.D];
    normalized.R = base[sum.R];
    normalized.E = base[sum.E];

    let type = "";
    const deviationArray = [];
    Object.keys(normalized).forEach((n) => deviationArray.push(normalized[n]));

    Object.keys(sum).forEach((s) => {
      Object.keys(strengthBase).forEach((t) => {
        if (!strength[s] && sum[s] >= strengthBase[t]) {
          strength[s] = t;
          if (t === "US") {
            let original = true;
            Object.keys(sum).forEach((st) => {
              if (st !== s && sum[st] >= strengthBase["S"]) original = false;
            });

            if (original) type = s;
          }
        }
      });
    });

    let max = 0;
    let maxType = "";
    if (!type) {
      Object.keys(normalized).forEach((s) => {
        if (max < normalized[s]) {
          max = normalized[s];
          maxType = s;
        }
      });

      max = 0;
      Object.keys(normalized).forEach((s) => {
        if (s !== maxType && max < normalized[s]) {
          max = normalized[s];
          type = s;
        }
      });

      type = maxType + type;
    }

    const n = deviationArray.length;
    const mean = deviationArray.reduce((a, b) => a + b) / n;
    const deviation =
      Math.floor(
        Math.sqrt(deviationArray.map((x) => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n) * 10
      ) / 10;

    return {
      title: "icruv2",
      type,
      sum,
      deviation,
      normalized,
      strength,
      reportType,
    };
  };

  useEffect(() => {
    const answer = location?.state?.answer || [];

    const sum = {
      A: 0,
      D: 0,
      R: 0,
      E: 0,
    };

    const sum2 = {
      A: 0,
      D: 0,
      R: 0,
      E: 0,
    };

    answer.map((item, index) => {
      if (item.answerType === "rank") {
        if (index % 2 === 0) {
          sum[item.answer[0].read] += 4;
          sum[item.answer[1].read] += 3;
          sum[item.answer[2].read] += 2;
          sum[item.answer[3].read] += 1;
        } else {
          sum2[item.answer[0].read] += 4;
          sum2[item.answer[1].read] += 3;
          sum2[item.answer[2].read] += 2;
          sum2[item.answer[3].read] += 1;
        }
      }
    });

    const icru = calculate(sum, "free");
    const icru2 = calculate(sum2, "stress");

    const diffR = sum2.R - sum.R;
    const diffE = sum2.E - sum.E;
    const diffA = sum2.A - sum.A;
    const diffD = sum2.D - sum.D;
    const diff = Math.max(diffR, diffE, diffA, diffD);
    let read;
    if (diffR === diff) read = "R";
    else if (diffE === diff) read = "E";
    else if (diffA === diff) read = "A";
    else if (diffD === diff) read = "D";

    icru.stressType = read;
    icru.stressSum = icru2.sum;

    setResult(icru);

    console.log("icru", icru, icru2);

    const interval = setInterval(() => {
      setDots((prev) => {
        if (prev.length === 3) return ".";
        return prev + ".";
      });
    }, 500);


    // ReportService.setHistory(icru).then((res) => {
      // console.log(res)
      // if (res.code === 200) {
      //   setResult(res.data);
            setTimeout(() => {
              clearInterval(interval);
              setIsComplete(true);
            }, 3000);

  //     }
  //   });

  }, [location?.state]);

  return (
    <PageWrapper className="black-body" title={'Test'}>
        <div className='test-bg'></div>
      <Page>
        <div className='row h-100 align-items-center justify-content-center'>
          <div className='col-xl-8 col-sm-8 text-center p-4 white'>
          {!isComplete && (
            <>
              <div className="font" item xs={8} lg={8} justifyContent="center" mx="auto" mt={0}>
                <h2>
                  진단 중
                </h2>
              </div>
                <div className="d-flex flex-row justify-content-center mt-5" item xs={8} lg={8} justifyContent="center" mx="auto" mt={0}>
                <div style={{width:220}}>
                  <h4
                    variant="h6"
                    color="white"
                    textAlign="center"
                    mb={1}
                    style={{
                      fontFamily: "Pretendard",
                      textAlign: "left",
                    }}
                  >
                      <span className="font">ICRU AI</span>가 <span className="font">{user.name}</span>님의<br/> 자기다움을 읽고 있습니다{dots}
                  </h4>
                </div>
              </div>
                <div className="d-flex flex-row justify-content-center mt-5" style={{height: 250}}>
                  {/* <MoonLoader color="#36d7b7" size={60} speedMultiplier={2} /> */}
                  <RingLoader color="#36d7b7" size={60} speedMultiplier={1} />
              </div>
            </>
          )}
          {isComplete && (
            <>
              <div className="font">
                <h2>
                  진단 완료
                </h2>
              </div>
              <div className="mt-5">
                <h4
                  variant="h6"
                  color="white"
                  textAlign="center"
                  mb={1}
                  style={{
                    fontFamily: "Pretendard",
                  }}
                >
                  ICRU기질진단이 완료되었습니다.
                  <br />
                  지금 바로 진단 결과를 확인하세요.
                </h4>
              </div>
                <div className="mt-5" item xs={8} lg={6} justifyContent="center" mx="auto" mt={5}>
                <img src={complete} alt="brand" width={150} />
              </div>
                <div className="mt-5" item xs={8} lg={6} justifyContent="center" mx="auto" mt={5}>
                <Button
                  variant="gradient"
                  color="success"
                  size="large"
                  sx={{ mb: 2 }}
                  style={{
                    background: "#03FF99",
                    borderRadius: "81.6801px",
                    fontFamily: "Pretendard",
                    fonttyle: "normal",
                    fontWeight: 800,
                    fontSize: "17.9696px",
                    color: "#004952",
                    width: "243px",
                    height: "55px",
                  }}
                  onClick={() => {
                    naviagte("/report", { state: { result } });
                  }}
                >
                  진단 결과 확인
                  </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </Page>
  </PageWrapper>
  );
}

export default Loading;
